module.exports = require("@native-ads/antd/es/menu/MenuItem");


//////////////////
// WEBPACK FOOTER
// external "@native-ads/antd/es/menu/MenuItem"
// module id = 117
// module chunks = 0